import { render } from "./BaseDropdownList.vue?vue&type=template&id=ed408336&scoped=true"
import script from "./BaseDropdownList.vue?vue&type=script&lang=js"
export * from "./BaseDropdownList.vue?vue&type=script&lang=js"

import "./BaseDropdownList.vue?vue&type=style&index=0&id=ed408336&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed408336"]])

export default __exports__